// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"176bfbff","247":"87ee917b","333":"9525b313","453":"603ca49b","902":"04d2e76f"}[chunkId] + ".chunk.js";
};